import { Save, Trash2 } from "lucide-react";

const RECURRING_CHOICES = [
  ["single", "Solo questo giorno"],
  ["future", "Questo giorno e i successivi"],
  ["all", "Tutte (passate e future)"]
];

const ghost = "px-4 py-2 rounded-full text-sm text-[#58635B] hover:bg-[#F3F5F0] transition-colors";
const danger = "tl-btn-primary inline-flex items-center gap-1.5 px-5 py-2 rounded-full bg-[#C48B97] hover:bg-[#B37A87] text-white text-sm font-medium transition-all";

// Bottom bar of the task dialog; the delete confirmation replaces the buttons in place.
export const DialogFooter = ({ editing, confirming, recurring, onAskDelete, onCancelDelete, onDelete, onClose }) => {
  if (confirming && recurring) {
    return (
      <div className="pt-2 border-t border-dashed border-[#E4E7E1]" data-testid="dialog-confirm-delete">
        <div className="text-sm font-medium text-[#3B443D] mt-3 mb-2">Cosa vuoi eliminare?</div>
        <div className="flex flex-col gap-2">
          {RECURRING_CHOICES.map(([s, label]) => (
            <button
              key={s}
              type="button"
              onClick={() => onDelete(s)}
              className="w-full text-left px-4 py-2.5 rounded-xl bg-white border border-[#E4E7E1] hover:border-[#C48B97] hover:text-[#B37A87] text-sm text-[#3B443D] transition-colors"
              data-testid={`dialog-delete-${s}`}
            >
              {label}
            </button>
          ))}
        </div>
        <div className="flex justify-end mt-2">
          <button type="button" onClick={onCancelDelete} className={ghost} data-testid="dialog-confirm-no">Annulla</button>
        </div>
      </div>
    );
  }
  if (confirming) {
    return (
      <div className="flex justify-between items-center gap-2 pt-2" data-testid="dialog-confirm-delete">
        <button type="button" onClick={() => onDelete()} className={danger} data-testid="dialog-confirm-yes">
          <Trash2 size={14} strokeWidth={1.75} /> Sì, elimina
        </button>
        <button type="button" onClick={onCancelDelete} className={ghost} data-testid="dialog-confirm-no">Annulla</button>
      </div>
    );
  }
  return (
    <div className="flex justify-between items-center gap-2 pt-2">
      {editing ? (
        <button
          type="button"
          onClick={onAskDelete}
          className="inline-flex items-center gap-1.5 px-4 py-2 rounded-full text-sm text-[#C48B97] hover:bg-[#F3F5F0] transition-colors"
          data-testid="dialog-delete"
        >
          <Trash2 size={14} strokeWidth={1.5} />
          Elimina
        </button>
      ) : <span />}
      <div className="flex items-center gap-2">
        <button type="button" onClick={onClose} className={ghost} data-testid="dialog-cancel">Annulla</button>
        <button type="submit" className="tl-btn-primary inline-flex items-center gap-1.5 px-5 py-2 bg-[#A3B897] hover:bg-[#8FA087] text-white rounded-full text-sm font-medium transition-all" data-testid="dialog-submit">
          <Save size={14} strokeWidth={1.75} />
          {editing ? "Aggiorna" : "Salva"}
        </button>
      </div>
    </div>
  );
};
